import { getAuth, onAuthStateChanged } from 'firebase/auth';

import { useLoginFlowState } from '@/composables/auth/useLoginFlowState';

export default defineNuxtPlugin((nuxtApp) => {
  const authStore = useAuthStore();
  const { exchangeToken } = useFirebaseTokenExchange();
  const { getLoginFlowInProgress } = useLoginFlowState();

  if (!import.meta.client) return;

  const initPromise = new Promise<void>((resolve) => {
    const auth = getAuth();

    onAuthStateChanged(auth, async(firebaseUser) => {
      try {
        authStore.firebaseUser = firebaseUser;

        if (firebaseUser && !getLoginFlowInProgress()) {
          await exchangeToken(firebaseUser);
        }
        await authStore.fetchUser();
      } catch (error) {
        console.error('❌ Auth error:', error);
      } finally {
        resolve();
      }
    });
  });

  nuxtApp.hook('app:beforeMount', () => initPromise);
});
